import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../Components/Layout/Layout';
import CreateBuyOfferModal from '../Components/Offers/CreateBuyOfferModal';
import { AuthContext } from '../contextStore/AuthContext';

const CreateBuyOfferPage = () => {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [showModal, setShowModal] = useState(true);

  const handleClose = () => {
    setShowModal(false);
    history.push('/');
  };

  const handleSuccess = () => {
    // Navigate to offers page or home after successful creation
    history.push('/');
  };

  if (!user) {
    return <Layout />;
  }

  return (
    <Layout>
      {showModal && (
        <CreateBuyOfferModal onClose={handleClose} onSuccess={handleSuccess} />
      )}
    </Layout>
  );
};

export default CreateBuyOfferPage;